<template>
  <section class="section partner-companies">
    <h2>{{ $t(`partner_companies_section.${page}`) }}</h2>
    <ScrollSlider
      :items="partnerCompanies"
      class="partner-companies__scroll-slider"
    >
      <template #scroll-slider-item="{ item: partnerData }">
        <div class="partner-companies__scroll-item">
          <PictureComponent
            :modern-format-image="{
              'desktop-path':
                partnerData.item.image['modern-format-image']['desktop-path'],
              'desktop-path-retina':
                partnerData.item.image['modern-format-image']['desktop-path-retina'],
            }"
            :fallback-format-image="{
              'desktop-path':
                partnerData.item.image['fallback-format-image']['desktop-path'],
              'desktop-path-retina':
                partnerData.item.image['fallback-format-image']['desktop-path-retina'],
            }"
            :alt="partnerData.item.name"
            loading="lazy"
          />
        </div>
      </template>
    </ScrollSlider>
  </section>
</template>

<script lang="ts">
import { PropType } from "vue";
import { User } from "~/types/entities";

import ScrollSlider, {
  IScrollSliderItem,
} from "~/components/slider/ScrollSlider.vue";

export default defineNuxtComponent({
  components: { ScrollSlider },
  props: {
    page: {
      type: String as PropType<User>,
      default: null,
    },
    partnerCompanies: {
      type: Array as PropType<IScrollSliderItem[]>,
      required: true,
    },
  }
});
</script>
<style scoped scss>
.partner-companies {
  :deep(.item) {
    max-width: 243px;
    align-items: center;
    justify-content: space-around;

    @media (max-width: 400px) {
      max-width: 45vw;
    }
  }
}
</style>